/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Word_To_Next_EventInputs */



/**
* | output |
* | --- |
* | "Move Word To Next Event" |
*
* @param {Shortcut_Keys_Name_Move_Word_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_word_to_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Move_Word_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Word_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wort zum nächsten Ereignis verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la parola all'evento successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перенести слово на следующее мероприятие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover palabra al siguiente evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将单词移至下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語を次のイベントに移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्द को अगले कार्यक्रम में ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover palavra para o próximo evento")
	return /** @type {LocalizedString} */ ("Move Word To Next Event")
});